"use strict";
// These are in WWWDB, but for the sake of performance,
// we don't want to do a JOIN to that table, thus it's
// better to just hardcode them into this constants file.
Object.defineProperty(exports, "__esModule", { value: true });
exports.WWW_COUPON_TO_OFFER_STATUSES = exports.WWW_COUPON_STATUSES = exports.WWW_OFFER_STATUSES = exports.WWW_OFFER_TYPES = void 0;
exports.WWW_OFFER_TYPES = {
    LEGACY_TRADEUP: 1,
    FF_20: 2,
    UPGRADE_30: 3,
    BOOST_30: 4,
    DEALER_UPGRADE: 5,
    UPGRADE_15: 6,
    RAF_FY21Q3: 7,
    RAF_REFERRER: 8,
};
exports.WWW_OFFER_STATUSES = {
    PENDING: 10,
    ELIGIBLE: 11,
    IN_PROGRESS: 12,
    ACTIVATED: 13,
    REDEEMED: 14,
};
exports.WWW_COUPON_STATUSES = {
    ELIGIBLE: 1,
    AVAILABLE: 2,
    CARTED: 3,
    REDEEMING: 4,
    REDEEMED: 5,
    CANCELLED: 6,
    REVOKED: 7,
    EXPIRED: 8,
};
exports.WWW_COUPON_TO_OFFER_STATUSES = {
    1: 11,
    2: 13,
    3: 13,
    4: 13,
    5: 14,
    6: 14,
    7: 14,
    8: 14,
};
//# sourceMappingURL=data:application/json;base64,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